const isEmptyObject = obj => {
    for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false
        }
    }
    return JSON.stringify(obj) === JSON.stringify({})
}

const fields = [
    'countryDialingCode',
    'areaDialingCode',
    'subscriberNumber',
    'extensionNumber'
]

function getPhonePatchesForAdd(editUser) {
    const patchValue = {}

    for (const field of fields) {
        if (editUser[field] !== null && editUser[field] !== '') {
            patchValue[field] = editUser[field]
        }
    }

    if (!isEmptyObject(patchValue)) {
        return [{ op: 'add', path: '/telephoneNumber', value: patchValue }]
    }

    return []
}

function getPhonePatchesForUpdate(editUser, originalUser) {
    const phonePatches = []
    for (const field of fields) {
        if (
            editUser[field] &&
            editUser[field] !== originalUser.telephoneNumber[field]
        ) {
            phonePatches.push({
                op: 'replace',
                path: `/telephoneNumber/${field}`,
                value: editUser[field]
            })
        } else if (
            originalUser.telephoneNumber[field] &&
            editUser[field] === '' &&
            editUser[field] !== originalUser.telephoneNumber[field]
        ) {
            phonePatches.push({
                op: 'remove',
                path: `/telephoneNumber/${field}`
            })
        }
    }

    return phonePatches
}

const getPhonePatch = (originalUser, editUser) => {
    if (originalUser.telephoneNumber === null) {
        return getPhonePatchesForAdd(editUser)
    }

    const removedAll = fields.every(field => !editUser[field])

    if (removedAll) {
        return [
            {
                op: 'remove',
                path: '/telephoneNumber'
            }
        ]
    }

    return getPhonePatchesForUpdate(editUser, originalUser)
}

const getPatch = (field, originalUser, editUser) => {
    const originalValue = originalUser[field]
    const editedValue = editUser[field]
    let patches = []

    if (originalValue === null) {
        if (editedValue) {
            patches.push({
                op: 'add',
                path: `/${field}`,
                value: editedValue
            })
        }
    } else if (editedValue !== originalValue) {
        const operation = !editedValue ? 'remove' : 'replace'
        patches.push({
            op: operation,
            path: `/${field}`,
            value: operation === 'replace' ? editedValue : undefined
        })
    }
    return patches
}

const getSalutationPatch = (originalUser, editUser) => {
    let patches = []
    const currentSalutation = originalUser.salutation
    const editedSalutation = editUser.salutation

    if (editedSalutation === 'UNKNOWN') {
        if (currentSalutation !== 'UNKNOWN') {
            patches.push({
                op: 'remove',
                path: '/salutation'
            })
        }
    } else if (currentSalutation !== editedSalutation) {
        const operation = currentSalutation === 'UNKNOWN' ? 'add' : 'replace'
        patches.push({
            op: operation,
            path: '/salutation',
            value: editedSalutation
        })
    }
    return patches
}

const getConsentPatch = (field, originalUser, editUser) => {
    let patches = []
    const originalValue = originalUser[field]
    const editedValue = editUser[field] ? 'GIVEN' : 'REFUSED'

    if (originalValue !== editedValue) {
        patches.push({
            op: 'replace',
            path: `/${field}`,
            value: editedValue
        })
    }
    return patches
}

const getDateOfBirthPatch = (originalUser, editUser) => {
    let patches = []
    let dateOfBirth = null
    if (
        editUser.birthdayYear &&
        editUser.birthdayMonth &&
        editUser.birthdayDay
    ) {
        dateOfBirth = `${editUser.birthdayYear}-${editUser.birthdayMonth}-${editUser.birthdayDay}`
    }

    if (dateOfBirth !== originalUser.dateOfBirth) {
        const operation = !originalUser.dateOfBirth ? 'add' : 'replace'
        patches.push({
            op: operation,
            path: '/dateOfBirth',
            value: dateOfBirth
        })
    } else if (
        !editUser.birthdayDay ||
        !editUser.birthdayMonth ||
        !editUser.birthdayYear
    ) {
        if (originalUser.dateOfBirth) {
            patches.push({
                op: 'remove',
                path: '/dateOfBirth'
            })
        }
    }
    return patches
}

const getPersonPatch = (originalUser, editUser) => {
    let personPatch = []

    if (editUser && editUser.crid) {
        personPatch.push(...getSalutationPatch(originalUser, editUser))
        ;[
            'title',
            'givenName',
            'surName',
            'position',
            'department',
            'preferredLanguage'
        ].forEach(field => {
            personPatch.push(...getPatch(field, originalUser, editUser))
        })
        personPatch.push(...getDateOfBirthPatch(originalUser, editUser))
        personPatch.push(
            ...getConsentPatch('consentMarketing', originalUser, editUser)
        )
        personPatch.push(
            ...getConsentPatch('consentRecherche', originalUser, editUser)
        )
        personPatch.push(...getPhonePatch(originalUser, editUser))
    }

    return personPatch
}

const getPatchCompany = (originalCrefonummer, selectedCrefonummer) => {
    const patch = [{ path: '/unverifiedCrefonummer', op: 'add' }]

    if (originalCrefonummer?.length && !selectedCrefonummer?.length) {
        patch[0].op = 'remove'
    } else if (selectedCrefonummer?.length) {
        patch[0].value = selectedCrefonummer
        if (originalCrefonummer?.length) {
            patch[0].op = 'replace'
        }
    }
    return patch
}


export { getPersonPatch, getPatchCompany }
